import { Stack, useTheme } from "@bps/fluent-ui";
import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { SectionTitle } from "@components/SectionTitle";
import { useOpsReportsDefinitions } from "@libs/api/gateways/plt-reports-ops/plt-reports-ops-gateway.hooks";

import { FmReportsTable } from "./FmReportsTable";

interface FieldManagementReportsProps {}

export const FieldManagementReports: React.FC<FieldManagementReportsProps> = ({}) => {
  const theme = useTheme();
  const reportsQuery = useOpsReportsDefinitions({
    metaData: {
      ReportType: "FM_Report"
    }
  });

  return (
    <QueryStateIndicator {...reportsQuery}>
      {reports => {
        return (
          <Stack
            verticalFill
            styles={{
              root: { padding: theme.spacing.s1, width: "100%" }
            }}
            tokens={{ childrenGap: theme.spacing.m }}
          >
            <SectionTitle>Field Management Reports</SectionTitle>
            <FmReportsTable items={reports} />
          </Stack>
        );
      }}
    </QueryStateIndicator>
  );
};

export interface FMReport {
  name: string;
  reportCode: string;
  description: string;
  reportLink: string;
  embedLink: string;
}
